import { render } from "./bloodGlucoseWrite.vue?vue&type=template&id=6ca85795&scoped=true"
import script from "./bloodGlucoseWrite.vue?vue&type=script&lang=js"
export * from "./bloodGlucoseWrite.vue?vue&type=script&lang=js"

import "./bloodGlucoseWrite.vue?vue&type=style&index=0&id=6ca85795&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca85795"]])

export default __exports__